import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';
import { LocalSaveService } from '../services/local-save-service.service';

// Correos genericos heredados (cuentas de contrata) que ya no deben tener
// sesion activa: cualquier sesion que tenga uno de estos correos guardado en
// localStorage se fuerza a login para que el usuario ingrese con sus credenciales
// nominales (no las genericas).
const BLOCKED_EMAILS = [
  'contratarepara@cpe.com',
  'contratainsta@cpe.com'
];

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {

	constructor(
		private _router: Router,
    private _loginservice: LoginService,
    private localSave: LocalSaveService,
	){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const url: string = state.url;

    // Bloquear sesiones de correos genericos heredados (contratainsta/contratarepara).
    // Si el localStorage tiene uno de estos correos, limpiamos la sesion y mandamos
    // al login.
    const storedEmail = this.localSave.get('email');
    const usuarioPGV = this.localSave.get('usuarioPGV');
    const correoPerfil = usuarioPGV && (usuarioPGV.OBJ && usuarioPGV.OBJ.correo || usuarioPGV.correo);
    const emailToCheck = (storedEmail || correoPerfil || '').toString().trim().toLowerCase();
    if (emailToCheck && BLOCKED_EMAILS.indexOf(emailToCheck) !== -1) {
      this._loginservice.clear();
      this._router.navigate(['/login']);
      return false;
    }

    if (this._loginservice.isAuthenticated()) {
        return true;
    }

    // navigate to login page
    this._router.navigate(['/login']);
    // you can save redirect url so after authing we can move them back to the page they requested
    return false;
  }
}
